import styled from 'styled-components';

const Container = styled.div`
  background-size: 250px;
  background: url('https://bigoventees.com/img/chooseUs.png');
  @media (min-width: 1024px) {
    padding: 32px 0;
    display: grid;
    width: 100%;
    align-items: center;
    min-height: auto;
  }
`;
const Wrapper = styled.div`
  margin-right: auto;
  margin-left: auto;
  max-width: 1200px;
  width: 100%;
`;
const Content = styled.div`
  display: grid;
  width: 100%;
  grid-gap: 30px;
  align-items: center;
  @media (min-width: 1024px) {
    grid-template-columns: 0.8fr 1fr;
    min-height: 450px;
  }
  img {
    width: 100%;
    max-height: 450px;
    object-fit: contain;
    object-position: center;
    @media (max-width: 767.98px) {
      width: auto;
      max-height: 260px;
      margin: 13px auto 0;
    }
  }
`;

const Section = styled.div`
  margin: 0 auto;
  position: relative;
  overflow: hidden;
  z-index: 1;
  padding: 15px;
  @media (min-width: 768px) {
    box-shadow: 0 0 20px 0 rgba(51, 51, 51, 0.25);
    padding: 15px 30px;
    border-radius: 15px;
    background: #000;
  }
`;
const Selector = styled.div`
  display: flex;
  justify-content: center;
  margin: 30px 0;
  Button {
    background: #000;
    opacity: 0.2;
    color: #fff;
    padding: 6px 12px;
    font-weight: 700;
    font-size: 15px;
    @media (max-width: 767px) {
      font-size: 12px;
    }
    &:last-child {
      border-radius: 0 50px 50px 0 !important;
    }
    &:first-child {
      border-radius: 50px 0 0 50px !important;
    }
  }
`;
export { Container, Wrapper, Section, Content, Selector };
